export const phoneNumber = '21 14 03 34';
